import attendance from './attendance';
import agents from './agents';
import auth from './auth';
import channel from './channel';
import chat from './chat';
import chatVisor from './chat-visor';
import contact from './contact';
import pause from './pause';
import jobs from './jobs';
import qualify from './qualify';
import system from './system';
import presetMessages from './preset-messages';
import tag from './tag';
import observation from './observation';
import bots from './bots';
import voice from './voice';
import whatsapp from './whatsapp';
import whatsappCampaigns from './whatsapp-campaigns';
import fastJob from './fast-job';
import dialogs from './dialogs';
import notifications from './notifications';
import attendanceGroups from './attendance-groups';
import broadcast from './broadcast';
import inlineEditing from './inline-editing';
import _connection from './_connection';
import _employer from './_employer';
import _campaigns from './_campaigns';
import sidebars from './sidebars';
import templatesMailing from './templates_mailing';
import { featureFlagStore } from '@/plugins/featureFlag';

// Modules
import email from '@/modules/email/infra/stores';
import colleagues from './colleagues';
import filters from './filters';

export default {
  attendance,
  agents,
  auth,
  channel,
  chat,
  chatVisor,
  contact,
  pause,
  jobs,
  qualify,
  system,
  presetMessages,
  tag,
  observation,
  bots,
  voice,
  whatsapp,
  whatsappCampaigns,
  fastJob,
  dialogs,
  notifications,
  attendanceGroups,
  broadcast,
  inlineEditing,
  _connection,
  _employer,
  _campaigns,
  sidebars,
  templatesMailing,
  email,
  colleagues,
  featureFlags: featureFlagStore,
  filters,
};
